"use client";import{name as c,version as t}from"../../package.json.mjs";const o={get:()=>"".concat(c,"-").concat(t),getMajor:()=>"".concat(c,"-").concat(t.split(".")[0])};export{o as packageDetails};
